var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.3329 20H5.66624C2.27696 20 6.10352e-05 17.6229 6.10352e-05 14.0843V5.91672C6.10352e-05 2.37811 2.27696 0 5.66624 0H14.3339C17.7232 0 20.0001 2.37811 20.0001 5.91672V14.0843C20.0001 17.6229 17.7232 20 14.3329 20",
    fill: "#999FA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24504 6.67496C9.24504 8.04496 8.13004 9.15997 6.76004 9.15997C5.38903 9.15997 4.27504 8.04496 4.27504 6.67496C4.27504 5.30496 5.38903 4.18896 6.76004 4.18896C8.13004 4.18896 9.24504 5.30496 9.24504 6.67496ZM17.4004 12.0876C17.6334 12.3136 17.8004 12.5716 17.9104 12.8466C18.2434 13.6786 18.0704 14.6786 17.7144 15.5026C17.2924 16.4836 16.4844 17.2246 15.4664 17.5486C15.0144 17.6936 14.5404 17.7556 14.0674 17.7556H5.68644C4.85244 17.7556 4.11444 17.5616 3.50944 17.1976C3.13044 16.9696 3.06344 16.4446 3.34444 16.1026C3.81444 15.5326 4.27844 14.9606 4.74644 14.3836C5.63844 13.2796 6.23944 12.9596 6.90744 13.2406C7.17844 13.3566 7.45044 13.5316 7.73044 13.7156C8.47644 14.2096 9.51343 14.8876 10.8794 14.1516C11.8132 13.641 12.3552 12.7673 12.8269 12.0069L12.8364 11.9916C12.8682 11.9407 12.8997 11.8898 12.931 11.8391C13.0915 11.5799 13.2495 11.3246 13.4284 11.0896C13.6504 10.7986 14.4744 9.88857 15.5394 10.5366C16.2184 10.9446 16.7894 11.4966 17.4004 12.0876Z",
    fill: "#999FA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.978858d1c83bbf086ae3bf032947948c.svg";
export { ForwardRef as ReactComponent };